<template>
  <unlogged-toolbar v-if="!authLoading">
    <div>
      <base-text v-if="toolbarText" color="white">{{ toolbarText }}</base-text>
    </div>
  </unlogged-toolbar>
  <the-toolbar v-else/>
  <maintenance-card v-if="configuration.isToShowAnnounce"/>
  <screen-loader is-auth v-show="authLoading"/>
  <main v-show="!authLoading" class="p-2 pt-8">
    <router-view></router-view>
  </main>
</template>

<script lang="ts" setup>
import {computed, onMounted, provide, ref} from 'vue';
import { useAuthStore } from '@/store/auth.store';
import { useRouter } from 'vue-router';
import UnloggedToolbar from '../../components/Toolbar/UnloggedToolbar.vue';
import TheToolbar from "@/components/Toolbar/TheToolbar.vue";
import BaseText from '../../components/Texts/BaseText.vue';
import MaintenanceCard from "@/components/Layouts/MaintenanceCard.vue";
import useApplicationConfig from "@/composable/controller/application/useApplicationConfig";
import ScreenLoader from "@/components/Loaders/ScreenLoader.vue";
import {useGetAuth} from "@/composable/controller/useUser";

const {authLoading} = useGetAuth();
const authStore = useAuthStore();
const router = useRouter();
const {configuration} = useApplicationConfig();

const toolbarText = ref<string>();
provide('setToolbarText', (value: string) => toolbarText.value = value);

onMounted(async () => {
  if (authStore.isAuthorized) {
    await router.push({ name: 'News' });
  }
});
</script>

<style scoped>

</style>
